<template>
  <ComponentNav/>

  <ComponentHero
  id="top"
  />

  <ComponentTitle
    :title="titlePresentation"
    id="presentation"
  />
  <ComponentPresentation
    :textPresentation="textPresentation"
    :linkPhoto="linkPhoto"
  />
  
  
  <ComponentTitle
    :title="titleAbout"
    id="about"
  />

  <ComponentContener/>

  <ComponentTitle
    :title="titleProjets"
    id="projets"
  />

  <ComponentCard 
  v-for="(project, index) in projects" 
      :key="index" 
      :projectName="project.name"
      :projectDescription="project.description"
      :projectTechnologies="project.technologies"
      :projectLink="project.link"
      :projectImage="project.img"
 />
 
  <ComponentTitle
    :title="titleSkill"
    id="skills"
  />

  <ComponentContenerSkill/>

  <ComponentTitle
    :title="titleContact"
    id="contact"
  />

  <ComponentContact/>

  <ComponentFooter/>

</template>

<script>
import ComponentNav from './components/ComponentNav.vue'
import ComponentCard from './components/ComponentCard.vue'
import ComponentHero from './components/ComponentHero.vue'
import ComponentTitle from './components/ComponentTitle.vue'
import ComponentContener from './components/ComponentContener.vue'
import ComponentPresentation from './components/ComponentPresentation.vue'
import ComponentContenerSkill from './components/ComponentContenerSkill.vue'
import ComponentFooter from './components/ComponentFooter.vue'
import ComponentContact from './components/ComponentContact.vue'
;

export default {
  components: {
    ComponentNav,
    ComponentCard,
    ComponentHero,
    ComponentTitle,
    ComponentContener,
    ComponentPresentation,
    ComponentContenerSkill,
    ComponentFooter,
    ComponentContact
  },
  data() {
    return {
      projects: [
        { name: 'Site de pointage des Bus / Transport scolaire', description: 'Site de pointage des bus pour le Lycée Léonard de Vinci.', technologies: ['VueJS','API'], link: '', img: './img/project/bus.png' },
        { name: 'Site de création de diplome d\'anniversaire', description: 'Animation Buffalo Grill, utiliser le code BG 38795', technologies: ['PHP', 'Tailwind CSS'], link: 'https://bgcalais.alwaysdata.net/diplome.php', img: './img/project/bg.png' },
        { name: 'Site d\'inscription CLJ', description: 'Site d\'inscription et d\'administration du centre de loisirs.', technologies: ['PHP', 'Symfony'], link: 'https://www.cljcalais.fr', img: './img/project/clj.png' },
        { name: 'Hide n Seek', description: 'Développement de la partie front avec ThreeJS', technologies: ['JS', 'ThreeJS'], link: '', img: './img/project/hidenseek.png' },
        { name: 'Nuit de L\'info 2022', description: 'Développement en équipe d\'un site internet', technologies: ['PHP', 'Tailwind CSS','DaisyUI'], link: '', img:'./img/project/ndli2022.png' },
        { name: 'Site CRUD', description: 'Developpement d\'un site CRUD, création, lecture, mise à jour et suppression de voyages', technologies: ['PHP', 'Symfony', 'TailwindCSS', 'DaisyUI'], link: '', img:'./img/project/crud.png' },
        { name: 'MineRL', description: 'Projet de recherche : développement d\'une IA pour la détection de blocs', technologies: ['Python'], link: '', img:'./img/project/minerl.png'},
      ],
      titleAbout: 'Mon parcours',
      titlePresentation: 'Présentation',
      textPresentation: 'Passionné par le développement web et les sciences des données, je suis titulaire d’un master dans ce domaine. Fort d’une expérience pratique en création d’applications web avec Vue.js, Node.js, MySQL et PHP. Proactif et curieux, je suis toujours à la recherche de nouvelles opportunités pour concevoir des solutions innovantes et fonctionnelles.',
      linkPhoto: './img/profil.png',
      titleProjets: 'Mes projets',
      titleSkill: 'Mes compétences',
      titleContact: 'Contact',
    };
  },
};

</script>

<style>

</style>
<style src="../src/assets/main.css"></style>
